import React from "react";
import { Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom';

function SubMenu(props) {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const history = useHistory();

  const pushLink = (link) => {
    history.push({
      pathname: link
    })
  }

  const showDropDown = props.showDropDown ? props.showDropDown : false;

  const SubMenuListParent = props.SubMenuNames.map((name, i) =>
    <li key={i} className={splitLocation[1] === `${name.link}` || name.active === true ? "active single-url" : "single-url"}><Link className="py-2 " id={name.slug} to={name.link}>{name.text}</Link></li>
  );
  const SubMenuList = props.SubMenuNames.map((name, i) =>
    <li key={i} className={splitLocation[2] === `${name.link}` || name.active === true ? "active double-url" : "double-url"}><Link className="py-2 " id={name.slug} to={name.link}>{name.text}</Link></li>
  );
  const SubmenuDropdownOptions = props.SubMenuNames.map((name, i) =>
    <option onClick={() => pushLink(name.link)} value={name.link} selected={splitLocation[2] === `${name.link}`}>
      {name.text}
    </option>
  );


  return (
    showDropDown ?
      <div className="Submenu">
        <div className="container submenu-with-dropdown">
          <select class="submenu-select" onChange={(e)=> pushLink(e.target.value)}>
            {SubmenuDropdownOptions}
          </select>
          <ul className="list-inline m-0 p-0 submenu-with-dropdown submenu-flex">
            {SubMenuList}
            {SubMenuListParent}
          </ul>
        </div>
      </div>
      :
      <div className="Submenu">
        <div className="container">
          <ul className="list-inline m-0 p-0 submenu-flex">
            {SubMenuList}
            {SubMenuListParent}
          </ul>
        </div>
      </div>
  );
}

export default SubMenu;

